import { render, staticRenderFns } from "./ListComponent.vue?vue&type=template&id=2f620146"
import script from "./ListComponent.vue?vue&type=script&lang=js"
export * from "./ListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jorgerebelo/Documents/Internal/corporate-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f620146')) {
      api.createRecord('2f620146', component.options)
    } else {
      api.reload('2f620146', component.options)
    }
    module.hot.accept("./ListComponent.vue?vue&type=template&id=2f620146", function () {
      api.rerender('2f620146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/wp-content/themes/kwankotheme/assets/js/components/campaigns_directory/ListComponent.vue"
export default component.exports